import request from '@/utils/request'


// 查询用户尿酸记录列表
export function listUricacid(query) {
  return request({
    url: '/joe/user-uricacid/list',
    method: 'get',
    params: query
  })
}

// 查询用户尿酸记录分页
export function pageUricacid(query) {
  return request({
    url: '/joe/user-uricacid/page',
    method: 'get',
    params: query
  })
}

// 查询用户尿酸记录详细
export function getUricacid(data) {
  return request({
    url: '/joe/user-uricacid/detail',
    method: 'get',
    params: data
  })
}

// 新增用户尿酸记录
export function addUricacid(data) {
  return request({
    url: '/joe/user-uricacid/add',
    method: 'post',
    data: data
  })
}

// 修改用户尿酸记录
export function updateUricacid(data) {
  return request({
    url: '/joe/user-uricacid/edit',
    method: 'post',
    data: data
  })
}

// 删除用户尿酸记录
export function delUricacid(data) {
  return request({
    url: '/joe/user-uricacid/delete',
    method: 'post',
    data: data
  })
}
